/**
 * Dectect browser feature and add necessary class to `<HTML>`
 */
import feature from '../../utils/feature';
import { isExperienceEditorMode } from '../../utils/functions';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  let initialized = false;
  
  return async () => {
    if (initialized) {
      // do not runs more then once
      return;
    }

    const $html = $('html');
    initialized = true;

    if (feature.noHover) {
      $html.addClass('-no-hover');
    }

    if (isExperienceEditorMode()) {
      $html.addClass('-sc-edit-mode');
    }
  };

})(jQuery, window);